module.exports = __webpack_public_path__ + "img/donate-alipay-100.19ef65b2.png";